/* var fileListArray = Array(document.querySelectorAll('.c-file-list'))[0];
if (fileListArray) {
	fileListArray.forEach(list=>{
		console.log(list)
		let anchor = list.querySelector('.c-file-list__title-container .c-link');
		anchor.addEventListener('click', e=>{
			e.preventDefault();
			const yOffset = -100;
			const element = anchor;
			let y;
			if(element === null){
				y = 0;
			}else{
				y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
			}
			window.scrollTo({top: y, behavior: 'smooth'});
		}) 
	});
} */

var anchors = [];
anchors = document.querySelectorAll('.c-side-bar__item');
//console.log(anchors)
anchors.forEach((tab) => {
	let anchor = tab.querySelector('.c-link')
	console.log(anchor)
	if (anchor) {
		
		anchor.addEventListener('click', (e) => {
			e.preventDefault();
			let id = e.currentTarget.getAttribute('href');

			//console.log(id);
			//console.log(document.getElementById(id.replace('#', '')));
			
			let yOffset = -120;
			let y = document.getElementById(id.replace('#', '')).getBoundingClientRect().top + window.pageYOffset + yOffset;
			window.scrollTo({ top: y, behavior: 'smooth' });
			/* if (window.scrollY != y) {
				setTimeout(() => {
				window.scrollTo({ top: y, behavior: 'smooth' });
				}, 150);
			} */
			//document.getElementById(id.replace('#',''))?.scrollIntoView({ top: 120, behavior: 'smooth' });
		});
	}
}); 

/* var anchors = [];
anchors = document.querySelectorAll('.c-side-bar__item');
console.log(anchors)
anchors.forEach((tab) => {
	let anchor = tab.querySelector('.c-link')
	console.log(anchor)
	anchor.addEventListener('click', (e) => {
		e.preventDefault();
		let id = e.currentTarget.getAttribute('href');
		let parentContainer = anchor.closest('.container')
		let el = parentContainer.querySelector('[data-id="'+id.replace('#', '')+'"]');
		console.log(id);
		console.log(el)
		//console.log(document.getElementById(id.replace('#', '')));
		
		let yOffset = -120;
		let y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
		window.scrollTo({ top: y, behavior: 'smooth' });
		// if (window.scrollY != y) {
		//	setTimeout(() => {
		//	window.scrollTo({ top: y, behavior: 'smooth' });
		//	}, 150);
		//}
		//document.getElementById(id.replace('#',''))?.scrollIntoView({ top: 120, behavior: 'smooth' });
	});
});  */